import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/mastersinfinance.webp';
import screenshot_target from '../../../images/letterfunnel/fransclaus.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Frans Claus"
      firstname="Frans"
      companyname="Masters in Finance"
      competition="TriFinance en USG Finance"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/fransclaus.js